import gql from 'graphql-tag';

export const getPlaces = gql`
  query {
    getPlaces {
      id
      slug
      name
      label
      type
      building
      image
      area
      floor
      floors
      shop {
        slug
        type
        name
        logo2Mob
        logo2Desk
        imgMob
        imgDesk
        ttPhone
        ttHours
        ttAllDays
        detail {
          ttTexte
        }
      }
    }
  }
`;
